<template>
  <div class="select-card">
    <div class="select-card-top">
      <div>组织架构</div>
      <div style="flex: 1">
        <div class="select-card-bottom">
          <div class="select-card-bottom-left">
            <!-- 数据维度 -->
            <el-cascader
              collapse-tags
              v-model="select_data_tree"
              :options="data_tree"
              :props="{
                multiple: true,
                label: 'deptName',
                value: 'deptIdOrOaAccount',
                checkStrictly: true,
              }"
              placeholder="组织架构"
              size="small"
              style="min-width: 240px"
              ref="cascader_jg"
              @change="change"
            >
              <template #default="{ data }">
                <span>{{ data.deptName }}</span>
              </template>
            </el-cascader>
            <el-button
              type="primary"
              size="mini"
              @click="querySelect(1)"
              :loading="isLoading"
              style="margin-left: 24px"
              >查询</el-button
            >
          </div>
        </div>
      </div>
      <ul class="tabs-con">
        <li
          v-for="(i, index) in tabs"
          :key="index"
          :class="tabsIndex == i.type ? 'li-active' : ''"
          @click="tabClick(index)"
        >
          {{ i.name }}
        </li>
      </ul>
    </div>
    <div class="select-card-bottom">
      <ChartLine2
        v-if="tabsIndex == 2 && isFlag"
        :id="2 + 'jg'"
        :tissueComparison="tissueComparison"
        :key="random"
      />
      <LineView
        v-if="tabsIndex == 1 && isFlag"
        :tissueComparison="tissueComparison"
        :id="1 + 'jg'"
        :key="random"
      />
    </div>
  </div>
</template>

<script>
import Bus from "@/utils/bus";
import ChartLine2 from "./chart_line_2.vue";
import Bar from "./bar";
import LineView from "./lineview";
import get_jg_list from "@/utils/jg";
export default {
  components: {
    ChartLine2,
    Bar,
    LineView,
  },
  props: ["chartType", "date"],
  data() {
    return {
      random: 0,
      dateParam: {},
      tabs: [
        {
          name: "柱状图",
          type: 1,
        },
        {
          name: "趋势图",
          type: 2,
        },
      ],
      tabsIndex: 1,
      select_data_tree: [], // 选中的数据维度权限
      data_tree: [], // 数据维度树
      goodsType: [], // 产品类目列表
      selectClass: [], // 选中的类目
      isLoading: false,
      isFlag: "",
      startTime: "",
      endTime: "",
      departSearchList: [],
    };
  },
  created() {
    console.log("组织架构-成本", this.date);
    this.startTime = this.date.startTime;
    this.endTime = this.date.endTime;
    this.querySelect();
    this.init();
  },
  methods: {
    async init() {
      let { data_tree, goodsType } = await get_jg_list.get_jg_list(2);
      this.data_tree = data_tree;
      this.goodsType = goodsType;
      console.log(goodsType);

      // console.log(this.data_tree);
      // console.log("组织架构-对比");
    },
    tabClick(val) {
      // console.log(val);
      this.tabsIndex = val + 1;
    },
    //组织架构选择
    change(val) {
      this.$nextTick(() => {
        let nodesObj = this.$refs["cascader_jg"].getCheckedNodes();
        let deptOne = {
            departCodes: [],
            level: 1,
          },
          deptTwo = {
            departCodes: [],
            level: 2,
          },
          deptThree = {
            departCodes: [],
            level: 3,
          },
          deptFour = {
            departCodes: [],
            level: 4,
          },
          deptFive = {
            departCodes: [],
            level: 5,
          };
        if (nodesObj.length > 0) {
          nodesObj.forEach((element, index) => {
            if (element.level == 1) {
              deptOne.departCodes.push(element.value);
            }
            if (element.level == 2) {
              deptTwo.departCodes.push(element.value);
            }
            if (element.level == 3) {
              deptThree.departCodes.push(element.value);
            }
            if (element.level == 4) {
              deptFour.departCodes.push(element.value);
            }
            if (element.level == 5) {
              deptFive.departCodes.push(element.value);
            }
          });
        }
        this.departSearchList = [
          deptOne,
          deptTwo,
          deptThree,
          deptFour,
          deptFive,
        ];
      });
    },
    // 根据日期判断是月的第几周

    // 查询数据
    querySelect() {
      // this.isLoading = true;
      // this.$store.dispatch("app/setLoading", true);
      let params = {},
        url = "PROFIT_DEPARTCOMPARE";
      this.departSearchList = this.departSearchList.filter((element, index) => {
        return element.departCodes.length > 0;
      });
      params = {
        departSearchList: this.departSearchList,
        end: this.endTime,
        start: this.startTime,
        timeType: 3,
      };
      // 数据请求
      this.axios
        .post(url, params)
        .then((result) => {
          console.log("费用-对比分析组织架构-查询返回", result);
          if (result.retCode == "200") {
            this.isFlag = true;
            this.tissueComparison = result.data;
          } else {
            this.$message.error(result.msg);
          }

          this.isLoading = false;
          this.random = Math.random();
          // this.$store.dispatch("app/setLoading", false);
          // this.$store.dispatch("data/setTotalData", result.data);
        })
        .catch(() => {
          this.isLoading = false;
          // this.$store.dispatch("app/setLoading", false);
        });
    },
    formatDate(number) {
      var date = new Date(number);
      var YY = date.getFullYear() + "-";
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      return YY + MM + DD;
    },
  },
};
</script>

<style>
@media (max-width: 1440px) {
  /* 小于1440 */
  .week-box {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .week-input2 {
    margin-right: 0 !important;
    margin-top: 10px;
  }
  .text-btn2 {
    margin-left: 8px !important;
  }
  .text-btn3 {
    margin-left: 8px !important;
    margin-right: 0px !important;
  }
  .select-day {
    margin-left: 12px !important;
  }
  .class-list {
    margin-left: 8px !important;
  }
}
</style>

<style scoped lang="scss">
.select-card {
  background: #ffffff;

  border-bottom-left-radius: none;
  border-bottom-right-radius: none;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  width: 100%;
  margin-top: 24px;
  box-shadow: 0px 4px 32px 0px rgba(64, 98, 117, 0.12);
  .select-card-top {
    color: #262626;
    font-weight: bold;
    font-size: 16px;
    padding: 13px 24px 13px 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .tabs-con {
      min-width: 100px;
      display: flex;
      flex-direction: row;
      li {
        flex: 1;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 20px;
        margin-left: 16px;
      }
      .li-active {
        color: #00b54b;
        border-bottom: 2px solid #00b54b;
        text-align: center;
         font-weight: 700;
      }
    }
    .question {
      width: 18px;
      height: 18px;
      margin-left: 5px;
    }
    .question:hover {
      cursor: pointer;
    }
  }
  .select-card-bottom {
    padding: 8px 24px 8px 24px;
    display: flex;
    flex-direction: row;
    // justify-content: space-between;
    align-items: center;
    .select-card-bottom-left {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      .class-list {
        margin-left: 24px;
        width: 200px;
      }
    }
    .select-card-bottom-right {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }
}
</style>